import { useState, useEffect, useCallback } from 'react';
import { fetchProductByHandle, ShopifyProduct } from '@/lib/shopify';

export function useShopifyProductsByHandles(handles: string[]) {
  const [products, setProducts] = useState<ShopifyProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const key = handles.join(',');

  const doFetch = useCallback(() => {
    if (!handles.length) {
      setProducts([]);
      setLoading(false);
      return () => {};
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    Promise.all(handles.map((h) => fetchProductByHandle(h)))
      .then((results) => {
        if (cancelled) return;
        const wrapped: ShopifyProduct[] = results
          .filter((r): r is NonNullable<typeof r> => r !== null)
          .map((node) => ({ node }));
        setProducts(wrapped);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [key]);

  useEffect(() => {
    return doFetch();
  }, [doFetch]);

  const refetch = useCallback(() => { doFetch(); }, [doFetch]);

  return { products, loading, error, refetch };
}
